$(document).ready(function () {

    /*ALIGN HEIGHT PRODUCT*/
    function alignHeight(selector) {
        $(selector).css('height', '');
        var minHeight = 0;

        $(selector).each(function () {
            if (minHeight < $(this).outerHeight()) {
                minHeight = $(this).outerHeight();
            }
        });

        if (minHeight > 0) {
            $(selector).css('height', minHeight);
        }
    }

    $('.slider-block.banner-slider ').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        autoplay: false,
        autoplaySpeed: 5000,
    });

    $('.review-esty-home').slick({
        slidesToShow: 3,
        dots:true,
        arrows: true,
        adaptiveHeight: true,
                  responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,

                    },
                }

            ],
    });

    if($('.collection-box .collection-item').length > 3) {
        const $carousel = $('.collection-box');
        const settings = {
            infinite: true,
            dots: false,
            arrows: true,
            slide: '.collection-item',
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '300px',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '150px',
                    },
                }

            ],
        };
        function setSlideVisibility() {
            const visibleSlides = $carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
            $(visibleSlides).each(function() {
                $(this).css('opacity', 1);
            });
            $(visibleSlides).first().prev().css('opacity', 0);
        }

        $carousel.slick(settings);
        $carousel.slick('slickGoTo', 1);
        setSlideVisibility();

        $carousel.on('afterChange', function() {
            setSlideVisibility();
        });
    }

    alignHeight('.page-collection .collection-item .image-box');
    alignHeight('.card-wrapper .jdgm-widget.jdgm-preview-badge');
    alignHeight('.section-review .review-items .description');
    alignHeight('.page-article .relatedArticles.page-width .article-card img');

    if (window.location.href.indexOf("contact%5Btags") > -1) {
        $('.custom__newform .newsletter__input-group input').addClass('error');
        $('.custom__newform .newsletter-form__message').removeClass('hidden');
    } else {
        $('.custom__newform .newsletter-form__message').addClass('hidden');
        $('.custom__newform .newsletter__input-group input').removeClass('error');
    }

    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

// Click function
    $('#tabs-nav li').click(function(){
        $('#tabs-nav li').removeClass('active');
        $(this).addClass('active');
        $('.tab-content').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
    });
    if ($(window).width() < 767)
    {
        $("ul.collection-block").on("click", ".init", function() {
            $(this).closest("ul").children('li:not(.init)').toggle();
            $(this).closest('ul').toggleClass('active');
        });
    }



})
